import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const StarIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="26" height="26" viewBox="0 0 26 26" {...props}>
    <path
      id="Path_21073"
      data-name="Path 21073"
      d="M1.438,13.425,5.3,16.243,3.831,20.781a3.5,3.5,0,0,0,5.4,3.9L13.006,21.9l3.774,2.774a3.5,3.5,0,0,0,5.4-3.892l-1.465-4.538,3.859-2.818A3.5,3.5,0,0,0,22.515,7.1h-4.74L16.337,2.62a3.5,3.5,0,0,0-6.662,0L8.237,7.1H3.5a3.5,3.5,0,0,0-2.059,6.321Z"
      transform="translate(-0.008 -0.19)"
      fill="#3477eb"
    />
  </Svg>
));

StarIcon.displayName = 'StarIcon';

export default StarIcon;
